// src/components/SubdomainRequiredRoute.jsx
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSubdomain } from '../contexts/SubdomainContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * サブドメインが必須の機能にアクセスするためのルートガード
 * サブドメインが登録されていない場合は登録ページにリダイレクト
 */
const SubdomainRequiredRoute = ({ children }) => {
    const { hasSubdomain, loading } = useSubdomain();
    const { accountId } = useParams();

    // サブドメイン情報の読み込み中
    if (loading) {
        return <LoadingSpinner />;
    }

    // サブドメインが登録されていない場合は登録ページにリダイレクト
    if (!hasSubdomain) {
        return <Navigate to={`/subdomain-setup/${accountId}`} replace />;
    }

    // サブドメインが登録済みの場合は子コンポーネントを表示
    return <>{children}</>;
};

export default SubdomainRequiredRoute;
